import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LoadService{

  private loadSource = new BehaviorSubject<number>(0);
  public loadCurrent = this.loadSource.asObservable();

  constructor(){
  }

/**
 * Cambia el porcentaje de la barra de carga. Si es 100, espera 1 seg y vuelve a 0.
 * @param msg valor mas actual del porcentaje
 */
  public loadChange(msg:number):void{
    if(msg === 100){
      this.loadSource.next(msg);
      setTimeout(()=>{
        this.loadSource.next(0);
      },100);
    }
    else{
      this.loadSource.next(msg);
    }
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/load.service.ts